import React, { createContext, useState, useEffect, useContext } from 'react';

type DocumentContext = {
    isActive: boolean;
};

/**
 * Hook
 * */
const DocumentContext = createContext<DocumentContext|null>(null);

export function useDocument() {
    return useContext(DocumentContext) as DocumentContext;
}

/**
 * Provider
 * */
export function DocumentProvider(props: { children: React.ReactNode }) {
    const [isActive, setIsActive] = useState(document.hasFocus());

    useEffect(() => {
        const onFocus = () => {
            setIsActive(true);
        };

        const onBlur = () => {
            setIsActive(false);
        };

        const onVisibilityChange = () => {
            setIsActive(document.hasFocus());
        };

        window.addEventListener('focus', onFocus);
        window.addEventListener('blur', onBlur);
        document.addEventListener('visibilitychange', onVisibilityChange);

        return () => {
            window.removeEventListener('focus', onFocus);
            window.removeEventListener('blur', onBlur);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    }, []);

    return <DocumentContext.Provider value={{ isActive }}>
        {props.children}
    </DocumentContext.Provider>;
}
